import { detectPlatform } from "@/lib/Platform";

/**
 * Electron 셸에서만 렌더링되는 드래그 가능 상단 바. 네이티브 신호등/캡션 버튼은
 * BrowserWindow(titleBarStyle) 가 그리므로 여기서는 건드리지 않고 그 뒤 배경만
 * 채운다 — 배경은 bg-background(테마 CSS 변수)를 그대로 따라가므로 IPC로 보내는
 * 창 배경색과 항상 자연히 동기화된다(apps/app/src/lib/theme.ts 참고).
 */
export function DesktopTitleBar() {
  if (detectPlatform() !== "desktop") return null;
  return (
    <div
      aria-hidden="true"
      className="app-drag-region fixed inset-x-0 top-0 z-50 h-[var(--app-titlebar-height)] bg-background"
    />
  );
}
